import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { Menu, Container, Image } from 'semantic-ui-react'
import { getAllToken } from "../../../lib/auth"
import { clearStateFormSearchName } from '../../rooms/actions'

const AuthFooter = (props) => {

	const home = () => {
		// props.clearStateFormSearchName()
		window.location.replace(`/`)
	}

	return (
		<Container>
			{
				getAllToken().access_token !== undefined &&
				<Menu size='mini' widths={3} fluid={true} borderless={true} icon='labeled' fixed='bottom'
					style={{ backgroundColor: '#010101', color: '#E0E0E0', height: '55px', textAlign: 'center' , zIndex:'2'}}>

					<Menu.Item name='video camera'
						// as={Link} to='/'
						onClick={() => home()}
						style={{ padding: '5px', fontSize: '1.5em' }}>
						<Image src={`/assets/images/icon_room.png`} style={{ width: 'auto', height: '45px' }} />
					</Menu.Item>

					<Menu.Item name='content' as={Link} to='/myreservationcoming' style={{ padding: '5px', fontSize: '1.5em' }}>
						<Image src={`/assets/images/icon_meeting.png`} style={{ width: 'auto', height: '45px' }} />
					</Menu.Item>

					<Menu.Item name='qrcode' as={Link} to='/qrcode' style={{ padding: '5px', fontSize: '1.5em' }}>
						<Image src={`/assets/images/icon_QR.png`} style={{ width: 'auto', height: '45px' }} />
					</Menu.Item>
				</Menu>
			}
		</Container>
	)
}

// export default AuthFooter

export default compose(
	withRouter,
	connect(
		state => ({

		}),
		(dispatch, props) => ({
			clearStateFormSearchName() {
				dispatch(clearStateFormSearchName())
			}
		})
	)
)(AuthFooter)


// WEBPACK FOOTER //
// ./src/features/ui/components/AuthFooter.js